export const IMPORT_STEPS = {
  INITIAL_STEP: 0,
  UPLOAD_FILE: 1,
  START_IMPORT: 2,
  FILE_PROCESSING: 3,
  UPLOAD_COMPLETED: 4,
  CANCEL: 5,
};

export const STEPS_TO_SHOW_INFO = [
  IMPORT_STEPS.UPLOAD_COMPLETED,
  IMPORT_STEPS.INITIAL_STEP,
  IMPORT_STEPS.FILE_PROCESSING,
];

export const STEPS_DESCRIPTION = ['Upload a File', 'Start Import', 'File Processing', 'Completed'];

export const IMPORT_POLLING_TIME = process.env.NODE_ENV === 'test' ? 0 : 6000;
export const REQUEST_NOTIFICATION_DELAY = process.env.NODE_ENV === 'test' ? 0 : 10000;

export const MIN_HEADER_HEIGHT = 54;
export const PAGE_CONTAINER_PADDINGS = 55;

export const ALLOWED_IMPORT_TYPES = ['zip'];

export const STATUSES = {
  COMPLETED: 'Success',
  IN_PROGRESS: 'Pending',
  ERROR: 'Fail',
  PENDING: 'Pending',
  CANCEL: 'Cancelled',
};

export const COMPLETED_LABEL = 'Complete';

export const APP_MIGRATION_IMPORT_APIS = {
  INITIATE_IMPORT: 'InitiateImport',
  IMPORT: 'Import',
  CHECK_STATUS: 'CheckStatus',
  DOWNLOAD_RESULT: 'DownloadResult',
  DOWNLOAD_INITIAL_FILE: 'DownloadInitialFile',
  IMPORT_HISTORY: 'ImportHistory',
  DOWNLOAD_TEMPLATE: 'DownloadTemplate',
  UPLOAD: 'Upload',
  CANCEL: 'Cancel',
  INSERT_ACTIVITY_LOG: 'InsertActivityLog',
};

export const ACTION_FOR_DUPLICATE_ITEM_OPTIONS = ['Overwrite', 'DeleteAndImport', 'Skip'];

export const UPLOAD_ERROR_MESSAGE = 'You can import only zip files';
export const UPLOAD_MAX_FILE_SIZE_ERROR_MESSAGE =
  'File size imported should not be greater than or equal to 24.4 MB';

export const NEW_IMPORT_KEY = 'NEW_IMPORT_KEY';

export const FORM_TYPE = 'Form';
export const WORKFLOW_TYPE = 'Workflow';

export const TYPES_TO_ALLOW_ACTIONS = [FORM_TYPE, WORKFLOW_TYPE];

export const FORM_LOG_FILE_NAME = 'FormLog.html';
export const WORKFLOW_LOG_FILE_NAME = 'WorkflowLog.html';

export const APP_MIGRATION_HISTORY_PAGE = '/application-migration?type=history';

export const UPLOAD_FILE_MAX_SIZE = 24400000;

export const cancelModalText =
  'By terminating the process, the remaining components will not be Imported. To Import the remaining components, you have to start the process from the beginning.';
